

export class PathologyModel{
  pathTypeCode ='' ;
  pathTypeName ='';
  pathTypeNotes= '';
  CompCode = '';
    userId ='';
  modifiedDate ='';

}




